import React, { useEffect, useState } from "react";
import { trainingApi } from "../../services/trainingApi";
import { StatusBadge } from "../StatusBadge";

/** Training tab - assignments, certifications, and retraining, reusing the single
 * consolidated `/training/employees/:id/profile` endpoint the backend already exposes. */
export const TrainingTab = ({ employeeId }) => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    trainingApi.employeeProfile(employeeId).then((r) => setProfile(r.data)).catch(() => setProfile(null));
  }, [employeeId]);

  if (!profile) return <p className="text-sm text-slate-500">Loading training record...</p>;

  return (
    <div className="space-y-5" data-testid="employee-training-tab">
      <div>
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Assigned courses</p>
        <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100">
          {profile.assignments.map((a) => (
            <div key={a.id} className="flex items-center justify-between px-4 py-2.5 text-sm" data-testid={`training-assignment-row-${a.id}`}>
              <span className="text-slate-700 font-medium">{a.course_title || a.course_id}</span>
              <StatusBadge status={a.status} />
            </div>
          ))}
          {profile.assignments.length === 0 && <p className="px-4 py-6 text-center text-sm text-slate-500" data-testid="no-training-assignments">No courses assigned yet.</p>}
        </div>
      </div>

      <div>
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Certifications</p>
        <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100">
          {profile.certifications.map((c) => (
            <div key={c.id} className="flex items-center justify-between px-4 py-2.5 text-sm" data-testid={`training-cert-row-${c.id}`}>
              <span className="text-slate-700 font-medium">{c.certification_name || c.certification_id}</span>
              <span className="text-slate-500">{c.expires_at ? `Expires ${c.expires_at}` : "No expiry"}</span>
            </div>
          ))}
          {profile.certifications.length === 0 && <p className="px-4 py-6 text-center text-sm text-slate-500" data-testid="no-training-certs">No certifications recorded.</p>}
        </div>
      </div>

      {profile.retraining.length > 0 && (
        <div>
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Retraining</p>
          <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100">
            {profile.retraining.map((r) => (
              <div key={r.id} className="flex items-center justify-between px-4 py-2.5 text-sm" data-testid={`training-retraining-row-${r.id}`}>
                <span className="text-slate-700 font-medium">{r.reason || r.course_id}</span>
                <StatusBadge status={r.status} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
